// extracted by mini-css-extract-plugin
export var orderSummary = "_qq-0";
export var showMoreLessButton = "_qq-1";